import "@/app/style/popUpSorter.scss";
import React, { RefObject } from 'react';
import Box from "@mui/material/Box";
import Popover from '@mui/material/Popover';
import { useLanguage } from '@/app/utils/LanguageContext';
import { textSize } from "@/app/utils/MixinSize";
import {Sort, Tick} from 'public/commsvg';
import { theme } from '@/app/utils/Common';
import { useMediaQuery } from "@mui/material";

const orders = ["asc","desc"] as const;
export type Order = typeof orders[number];
export type Sorting = {
    key: string;
    label: string;
    type: "numerical" | "alphabetical";
}

type propType = {
    sortings: Sorting[];
    selectedOrder: Order;
    selectedOrderBy: string;
    handleChangeSorting: (sorting: Sorting, order: Order) => void;
    anchorEl: RefObject<HTMLDivElement | null> | null;
}

const PopUpSorter: React.FC<propType> = (props: propType) => {
    const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
    const { state: lang } = useLanguage();
    const { t } = lang;
    const [open, setOpen] = React.useState(Boolean(false));
    const id = open ? 'simple-popover' : undefined;

    const { sortings, selectedOrder, selectedOrderBy, anchorEl, handleChangeSorting } = props;

    const handleClose = () => {
        setOpen(false);
    };

    const onClickSorting = (sorting: Sorting, order: Order) => {
        if (handleChangeSorting) {
            handleChangeSorting(sorting, order);
        }
        handleClose();
    };

    const onClickIcon = (event: React.MouseEvent<HTMLImageElement, MouseEvent>) => {
        if (open) {
            handleClose();
        } else {
            setOpen(true);
        }
    };

    const isMatchedItem = (sorting: Sorting, order: Order) => sorting.key === selectedOrderBy && order === selectedOrder;
    
    const resetDefaultSort = () => {
        const defaultOption = {
            "key": "HorseNumber",
            "label": "Horse No.",
            "type": "numerical"
        } as Sorting;

        handleChangeSorting(defaultOption, 'asc');
        handleClose();
    }

    return (
        <>
            <div className="mobileSortingIcon" onClick={onClickIcon}>
                <Sort />
            </div>
            <Popover
                id={id}
                open={open}
                onClose={handleClose}
                anchorEl={anchorEl?.current}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                className="popupSorting"
            >
                <Box sx={{ width: "200px", ...textSize(13), fontWeight: 500 }}>
                    <Box className="commHeaderTitle sortingTitle" id="sortingTitle">{t("sorting")}</Box>
                    <Box className="mobile_sortingPop">
                        {
                            sortings.map((option: Sorting, idx: number) =>
                                <div id={`sorting_${option.key}`} key={idx}>
                                    <div id={`sortingLbl_${option.key}`} className={`sortingLabel${option.key===selectedOrderBy?' selected': ''}`}>{option.label}</div>
                                    <div id={`sortingOpt_${option.key}`}>
                                        {
                                            orders.map((order: Order, idx: number)=>
                                            <>
                                                <div key={idx} id={`sortingOpt_${option.key}_${order}`} className={`sortingOpt${isMatchedItem(option, order)?' selected': ''}`} onClick={()=>onClickSorting(option, order)}>
                                                    {
                                                        isMatchedItem(option, order) && <div className="icon"><Tick /></div>
                                                    }
                                                    {t(`sorting_${option.type}_${order}`)}
                                                </div>
                                                {idx === 0 ? <div className="sortingDivider"/> : null}
                                            </>
                                            )
                                        }
                                    </div>
                                </div>
                            )
                        }
                    </Box>
                    <div
                        className="resetSortingBtn"
                        onClick={() => resetDefaultSort()}>
                            <p>{isMobile ? t("sorting_Btn_Mobile"): t("sorting_Btn_PC")}
                        </p>
                    </div>
                </Box>
            </Popover>
        </>
    )
}

export default PopUpSorter;